import React from 'react';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

type Props = {
    topics: Array<string>,
    onChange: (topic: string) => void,
    selectedTopic: string,
};

export const NotificationTopicFilter = ({topics, onChange, selectedTopic}: Props) => {
    return (
        <Group style={{width: 200}} direction="v">
            <Label>Topics</Label>
            {topics ? (
                <ComboBox
                    value={selectedTopic || ''}
                    onChange={onChange}
                    placeholder="All topics">
                    {[
                        ...topics.map((topic: string) => (
                            <ComboboxItem key={topic} value={topic} caption={topic}/>
                        )),
                    ]}
                </ComboBox>
            ) : null}
        </Group>
    );
};
